module.exports = __webpack_public_path__ + "img/20_88.5b64fac4.png";